
import LogServices from "./LogServices";
export default {
  LogEventPost(data) {
    return LogServices.post("/logEvent/Create", data);
  },
};
